<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!product">
      <span class="loader"></span>
    </span>
    <product-form
      v-if="product"
      :loading="loading"
      :productData="product"
      :formErrors="formErrors"
      @productSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import ProductForm from "../partials/ProductForm.vue";

export default {
  layout: "DashboardLayout",

  components: { ProductForm },

  mixins: [alertLeave],

  props: {
    productId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      product: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("products/get", this.productId);
        this.product = this.$store.getters["products/product"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(product) {
      this.loading = true;
      const productData = cloneDeep(product);

      try {
        await this.$store.dispatch("products/update", productData);
        this.$notify({
          type: "success",
          message: this.$t("PRODUCTS.PRODUCT_UPDATED"),
        });
        const product = this.$store.getters["products/product"];
        this.$emit("onViewProduct", product, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
